export const getAddress = (user = {}) => {
  const { line1, city, zip, state, country } = user?.address || {};
  let parts = [];
  if (line1) parts.push(line1);
  if (city) parts.push(city);
  if (zip) parts.push(zip);
  if (state) parts.push(state);
  if (country) parts.push(country);

  if (parts.length === 0) {
    return 'No address registered';
  }
  return parts.join(', ');
};

export const loggedIn = () => {
  const { token } = JSON.parse(localStorage.getItem('data')) || {};
  return token;
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('data'))?.user;
};

export const defaultAvatar = require('@/assets/billfish-logo-new.png');

export const setRequestedUserData = (input) => {
  const data = window.structuredClone(input);
  const { angler, captain, firstMate, secondMate } = data || {};
  return {
    ...data,
    angler: getRequestedUserData(angler),
    captain: getRequestedUserData(captain),
    firstMate: getRequestedUserData(firstMate),
    secondMate: getRequestedUserData(secondMate)
  };
};

export const getRequestedUserData = (user) => {
  return {
    id: user?._id || user?.id,
    legacyId: user?.legacyId,
    firstName:
      user?.firstName ||
      (user?.fullName ? user.fullName.split(' ')[0] : undefined),
    lastName:
      user?.lastName ||
      (user?.fullName
        ? user.fullName.split(' ').slice(1).join(' ')
        : undefined),
    middleName: user?.middleName,
    suffixName: user?.suffixName,
    email: user?.email,
    memberId: user?.memberId,
    memberExpiration:
      user?.memberExpiration || user?.membership?.expirationDate,
    address: user?.address?.line1,
    city: user?.address?.city,
    state: user?.address?.state,
    zip: user?.address?.zip,
    country: user?.address?.country
  };
};
